module.exports = {
	"Info": "Z programowaniem mam styczność od około sześciu lat, przez ostatnie cztery koduję aktywnie używając GitHub. Posiadam dyplom technika informatyka oraz licencjat z Filologii Angielskiej. W programowaniu moim konikiem jest JavaScript. Technologie w jakich pracowałem najdłużej: React, Node, Next.js.  Ponadto dobrze czuję się także w zagadnianiach MERN i AWS(deploy na ubuntu). W swojej karierze poza JS stworzyłem kilka skryptów w python, oraz zaprogramowałem kilka mikrokontrolerów. Poza programowaniem interesuje się ekonomią, inwestowaniem i IoT.",
	"Technologies": {
		"title": "Mój stack",
		"technologies": [
			[
				"React.js",
				"React jest biblioteką w której napisałem najwięcej stron. Rozumiem jego podstawy ale także i średnio-zaawansowane zagadnienia. Reacta używam w każdej ze swoich aplikacji webowych. "
			],
			[
				"Next.js",
				"W next.js tworzyłem aplikacje webowe, wybrałem go zaraz po reakcie, gdyż upraszczał on budowę api oraz optymalizował ładowanie zdjęć czy podstron. Zbudowałem w nim klona monopoly-moją dotychczas najbardziej rozbudowaną aplikację. Z nextem używałem: Firebase, recoil, testowałem też mongodb i express. Oczywiście rodzaje renderowania jakie oferuje next też przetestowałem, lecz nie stworzyłem żadnej aplikacji dla potwierdzenia."
			],
			[
				"MERN stack",
				"Z MERN stack zapoznałem się stosunkowo niedawno, podszedłem do niego z dobrą znajomością Node, oraz zaraz po Next.js więc załapanie architektury nie sprawiło mi problemów. Rozumiem jak działa warstwa middleware z expressem, JWT. Wiem że wszystkiego niewiem, ale z chęcią się dowiem."
			],
			[
				"Node.js",
				"Zacząłem z niego korzystać podczas przepisywania jednej ze swoich aplikacji napisanych w react (drzewo genealogiczne). Ostatecznie aplikacja została w react, ale przygoda z Node dopiero się zaczęła. Później Node.js to dla mnie długie i przyjemne godziny spędzone nad symulacją użytkownika z wykorzystaniem pupetter czy mineflayer. "
			],
			[
				"Dodatki",
				"Dodatkowo napisałem kilka małych programów w Python, jeden z nich zmieniał rozmiar zdjęć i zapisywał breakpointy w css. Teraz oczekuję na Raspberry Pi Pico W aby zacząć projekty w python korzystające z api pythona. Dodatkowo stworzyłem zdalnie sterowany model od podstaw, programując mikrokontroler, lutując moduły komunikacji zdalnej. Ten projekt nauczył mnie składni podobnej do języka C oraz pokazał mi jak działają podzespoły w urządzeniach elektronicznych."
			]
		]
	},
	"title1": "Miękkie",
	"SoftList": [
		"Angielski B2",
		"Pasjonat IoT",
		"Szybki Gugle",
		"Wytrwały"
	],
	"title2": "Narzędzia",
	"Tools": [
		"Scrum",
		"Figma",
		"VSCode",
		"CMD",
		"Postman"
	],
	"title3": "Tło",
	"ShortStory": "Programowaniem zajawiłem się pod koniec gimnazjum, zrobienie czegoś z niczego dawało sporo frajdy. Pierwszy projekt jaki pamiętam był w php, js, html i jQuery, bardzo proste logowanie użytkownika. Następnie w technikum złapałem zajawkę na programowanie arduino, chciałem zrobić drona ale wyszedł zdalnie sterowany samochód - nie zakładałem okularów podczas robienia projektu B). Do ukończenia technikum m.in. potrzebna była znajomość stacku LAMP, oraz sieci internetowych. Wybrałem studia anglojęzyczne aby móc pobocznie nadal uczyć się programować, na studiach oprócz języka poznałem zagadnienia ze świata biznesu, odbyłem kilkaset godzin praktyk i napisałem pracę licencjacką pod tytułem Software starutps - theory and practice, na rzecz której powstała aplikacja monopoly.  "
};


//////////////////
// WEBPACK FOOTER
// ./src/data/pl.json
// module id = 36
// module chunks = 0